import { render, staticRenderFns } from "./AstrolabeCanvas.vue?vue&type=template&id=6da5e30f&scoped=true"
import script from "./AstrolabeCanvas.vue?vue&type=script&lang=js"
export * from "./AstrolabeCanvas.vue?vue&type=script&lang=js"
import style0 from "./AstrolabeCanvas.vue?vue&type=style&index=0&id=6da5e30f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da5e30f",
  null
  
)

export default component.exports